import styled from 'styled-components';

export const PackageCarouselStyled = styled.div`
  .newPackageSection {
    .packageCarousel {
      .slick-list {
        .slick-track {
          margin-left: 6px;
        }
      }
    }
  }

  .newPackageDetail{
    width: 100%;
    padding: 0px;
  }

  .packageCarousel {
    width: 100%;
    .slick-next {
        right: -20px;
      }
      .slick-prev {
        left: -18px;
      }


    .packageCardWrapper {
      width: 202px;
      height: 347px;

      .card-body {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
        isolation: isolate;
        width: 203px;
        height: 263px;
        border-radius: 8px;
        padding: 8px 10px;
      }

      .packageImage {
        padding: 0;
        border-radius: 6px;
        border: 1px solid ${(props) => props?.theme?.grey?.ddd};
        width: 186px;
        height: 104px;
        object-fit: fill;
        background: ${(props) => props?.theme?.blue?.iconBg};
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      .packageName {
        width: 176px;
        height: 56px;
        font-weight: 600;
        font-size: 15px;
        line-height: 18px;
        color: ${(props) => props?.theme?.text?.dark};
        margin-top: 3px;
      }

      .packageServices {
        width: 100%;
        font-weight: 700;
        font-size: 11px;
        line-height: 16px;
        color: ${(props) => props.theme.color.astercoreYellow};
      }

      .amountBlock {
        width: 186px;
        height: 20px;
        padding: 0px;
        gap: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .packageAmount {
          font-size: 16px;
          font-weight: 700;
          line-height: 19px;
          height: 19px;
          color: ${(props) => props?.theme?.text?.dark};
          white-space: nowrap;
        }

        .packageSaveAmount {
          font-weight: 500;
          font-size: 12px;
          line-height: 15px;
          color: ${(props) => props?.theme?.green?.dark};
          cursor: pointer;
          width: 100%;
          height: 15px;
          white-space: nowrap;
          text-align: left;
        }
      }

      .offerExpires {
        /* width: 94%; */
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 2px 0px 2px 6px;
        margin-top: -4px;
        gap: 6px;
        height: 21px;
        background: ${(props) => props?.theme?.color?.white};
        border-radius: 2px;
        position: absolute;
        border-radius: 2px;
        transform: translate(0, -105%);
        border: 1px solid ${(props) => props?.theme?.verification?.red?.off};
        border-top: none;

        .offer {
          width: 62px;
          height: 16px;
          font-weight: 600px;
          padding: 1px 1px 2px 0;
          font-size: 10px;
          line-height: 13px;
          color: grey;
          flex: none;
          order: 0;
          flex-grow: 0;
        }

        .expire {
          width: 62%;
          display: flex;
          flex-direction: row;
          height: 21px;
          padding: 1px 4px 4px 2px;
          background: ${(props) => props?.theme?.verification?.red?.off};
          flex: none;
          order: 1;
          flex-grow: 0;
          border-radius: 2px;

          .ic {
            left: 8px;
            top: 4px;
            margin: 0 2px 2px 3px;
            font-weight: 600;
            color: ${(props) => props?.theme?.color?.red};
          }

          .expireDate {
            height: 13px;
            left: 20.88px;
            top: 6px;
            padding: 4px 1px 4px 0;
            font-weight: 700;
            font-size: 10px;
            line-height: 13px;
            color: ${(props) => props?.theme?.color?.red};
          }
        }
      }
      .viewMoreBlock {
        padding: 0px 16px 16px 0px;
        margin-top: 22px;
        gap: 2px;
        width: 186px;
        height: 20px;
        border-radius: 8px;
        align-items: center;
        background: ${(props) => props?.theme?.color?.white};

        .viewDetails {
          font-size: 15px;
          line-height: 16px;
        }
      }
    }
  }

  @media (max-width: 480px) {
    .packageCarousel {
      .slick-slide {
        margin-right: 16px;
      }
    }
  }
`;
